/* Woodbe Premium — motion + header behaviour for the custom .wb sections */
(function(){
  var d=document, root=d.documentElement;
  var forced=/[?&]static\b/.test(location.search) || (window.Shopify && Shopify.designMode);
  if(forced) root.classList.add('force-reveal');
  window.addEventListener('load',function(){root.classList.add('loaded')});

  function initReveal(scope){
    var els=[].slice.call((scope||d).querySelectorAll('.wb .reveal:not(.in)'));
    if('IntersectionObserver' in window && !forced){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
      },{rootMargin:'0px 0px -8% 0px',threshold:.08});
      els.forEach(function(el){
        var sib=[].slice.call(el.parentNode.children).filter(function(c){return c.classList.contains('reveal')});
        el.style.transitionDelay=(Math.min(sib.indexOf(el),4)*80)+'ms';
        io.observe(el);
      });
    } else { els.forEach(function(el){el.classList.add('in')}); }
  }

  function initHeader(){
    var header=d.querySelector('.wb .site-header');
    if(!header || header.dataset.wbInit) return; header.dataset.wbInit='1';
    var onScroll=function(){ header.classList.toggle('scrolled', window.scrollY>8); };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    var btn=header.querySelector('.js-menu-toggle'), menu=d.getElementById('wb-mobile-menu');
    if(btn && menu){
      btn.addEventListener('click',function(){
        var open=menu.hasAttribute('hidden');
        var r=header.getBoundingClientRect(); menu.style.setProperty('--mm-top', Math.max(r.bottom,0)+'px');
        if(open){menu.removeAttribute('hidden');} else {menu.setAttribute('hidden','');}
        btn.setAttribute('aria-expanded',open); btn.classList.toggle('menu-open',open);
        var l=btn.querySelector('.menu-label'); if(l) l.textContent=open?(btn.dataset.close||'Close'):(btn.dataset.open||'Menu');
        d.body.style.overflow=open?'hidden':'';
        root.classList.toggle('menu-is-open',open);
      });
    }
    var sp=d.getElementById('wb-search-panel');
    if(sp){
      d.querySelectorAll('.js-search-open').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();sp.removeAttribute('hidden');var i=sp.querySelector('input');if(i)i.focus();});});
      d.querySelectorAll('.js-search-close').forEach(function(b){b.addEventListener('click',function(){sp.setAttribute('hidden','');});});
      d.addEventListener('keydown',function(e){ if(e.key==='Escape') sp.setAttribute('hidden',''); });
    }
  }

  // Keep the sticky header below fixed app bars (e.g. Free Shipping Bar) when present
  function syncFixedTop(){
    var fsb=d.getElementById('fsb_background');
    var h=0;
    if(fsb && getComputedStyle(fsb).position==='fixed' && fsb.offsetHeight){ var r=fsb.getBoundingClientRect(); if(r.top<=0) h=Math.round(r.bottom); }
    root.style.setProperty('--wb-fixed-top', h+'px');
  }
  function watchFixedTop(){
    syncFixedTop();
    window.addEventListener('resize',syncFixedTop,{passive:true});
    if('MutationObserver' in window){ new MutationObserver(function(){ syncFixedTop(); }).observe(d.body,{childList:true}); }
    setTimeout(syncFixedTop,1500); setTimeout(syncFixedTop,4000);
  }
  function init(){ initReveal(); initHeader(); watchFixedTop(); }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',init); else init();
  // Theme editor: re-run when sections are added/re-rendered
  d.addEventListener('shopify:section:load',function(e){ initReveal(e.target); initHeader(); });
})();
